export enum ErrorCode {
  NOT_ENOUGH_PERMISSIONS = 'NOT_ENOUGH_PERMISSIONS',
  INVALID_DATA = 'INVALID_DATA',
  MISSING_USER_EMAIL = 'MISSING_USER_EMAIL',
}
